import React, {useCallback, useEffect, useState} from 'react';
import {Card, CardBody, Row} from "reactstrap";
import Reports from "./component/Reports";
import {ResultApi} from "../services/services";

const Comparison = (props) => {
    const [result, setResult] = useState([])
    const [Id, setId] = useState(null)

    const Result = useCallback(async () => {
        const id = JSON.parse(localStorage.getItem("Comparison"))
        setId(id)
        const result = await ResultApi(id)
        setResult(result?.data)
    })

    useEffect(() => {
        Result()
    }, [])

    const onClick = (id) => {
        let ids = Id
        if (ids.includes(id)) {
            ids = ids.filter(i => i !== id)
        }

        localStorage.setItem("Comparison",JSON.stringify(ids))
        setId(ids)
        Result()
    }
    return (
        <>
            <div className="content">
                <Row className={"justify-content-center"}>
                    {
                    }
                    {
                        result.length===0?
                            <Card>
                                <CardBody className={'text-center '}>
                                    داده ای برای مقایسه وجود ندارد
                                </CardBody>
                            </Card>
                            :
                            result && result.map((r, i) => (
                                <Reports data={r}
                                         boxId={Id[i]}
                                         onClick={onClick}
                                />
                            ))
                    }
                </Row>
            </div>
        </>
    )
}

export default Comparison;